export const ALL_LIST = "Can review all rows";
export const USER_LIST = "Can review only their rows";
export const EDIT_DECLARANT = "Edit rows in Declarant table";
export const EDIT_LOGISTIC = "Edit rows in Logistic table";
export const DELETE_DECLARANT = "Delete rows in Declarant table";
export const UPLOAD_XML = "Upload XML";
export const DOWNLOAD_XML = "Download XML";
export const ALL_FIELDS = "Can see additional columns";
export const MANUAL_CREATION = "Manual creation";
export const ACCESS_TO_DEPARTMENTS_DATA = "Access to Departments Data";
export const ACCESS_TO_BY_CLIENTS = "Access to By Clients";
export const ALL_DATA_IN_DEPARTMENT_DATA = "All data in Departments";
export const CAN_USE_CALCULATOR = "Can use Calculator";
export const WORK_WITH_CASH = "Work with Cash";
export const ACCESS_TO_CASHBOX = "Full access to Cashbox";
export const EDIT_DATA_AFTER_HAND_OVER = "Edit Department Data after Hand Over";
export const ACCESS_TO_FLEET_EXPENSES = "Access to Fleet Expenses";

// CMR permissions
export const HAS_ACCESS_TO_CMR = "Has access to the CMR";
export const CAN_CREATE_AND_EDIT_CMR = "Can create and edit CMR";
export const CAN_DELETE_CMR = "Can delete CMR";
export const CAN_DOWNLOAD_CMR = "Can download CMR";

export type Permission =
  | typeof ALL_LIST
  | typeof USER_LIST
  | typeof EDIT_DECLARANT
  | typeof DELETE_DECLARANT
  | typeof UPLOAD_XML
  | typeof DOWNLOAD_XML
  | typeof ALL_FIELDS
  | typeof MANUAL_CREATION
  | typeof ACCESS_TO_DEPARTMENTS_DATA
  | typeof ACCESS_TO_BY_CLIENTS
  | typeof ALL_DATA_IN_DEPARTMENT_DATA
  | typeof CAN_USE_CALCULATOR
  | typeof WORK_WITH_CASH
  | typeof ACCESS_TO_CASHBOX
  | typeof EDIT_DATA_AFTER_HAND_OVER
  | typeof EDIT_DATA_AFTER_HAND_OVER
  | typeof ACCESS_TO_FLEET_EXPENSES
  | typeof HAS_ACCESS_TO_CMR
  | typeof CAN_CREATE_AND_EDIT_CMR
  | typeof CAN_DELETE_CMR
  | typeof EDIT_LOGISTIC
  | typeof CAN_DOWNLOAD_CMR;

export type PermissionType = Permission | Array<Permission>;

export const ROLE_ADMIN = "admin";
export const ROLE_CLIENT = "client";
export const ROLE_EMPLOYEE = "employee";
export const ROLE_DECLARANT = "declarant";

export type Role =
  | typeof ROLE_ADMIN
  | typeof ROLE_CLIENT
  | typeof ROLE_EMPLOYEE
  | typeof ROLE_DECLARANT;

export type RoleType = Role | Array<Role>;
